/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect } from "react";
import moment, { Moment } from "moment";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import "./CalendarStrip.css";
import ICalendarStripProps from "components/CalendarStrip/ICalendarStripProps";

import "moment/locale/it";
import { performAsyncFunction } from "utils/AsyncFunctionUtility";
import { Spin } from "antd";
import { Enhanced } from "utils/ReactUtils";

const CalendarStrip: React.FC<ICalendarStripProps> = ({
	selectedDate,
	OnClick,
	AvailableDates,
	PopolaDisponibilitaSettimanale,
	handleError,
	i18n,
	t,
}) => {
	const [dates, setDates] = useState<Moment[]>([]);
	const [loading, setLoading] = useState<boolean>(false);

	useEffect(() => {
		const tempDates = [];
		moment.locale(i18n.language);

		let startDate = moment(selectedDate).startOf("week");
		if (!startDate.isSame(dates[0])) {
			for (let i = 0; i < 7; i++) {
				var date = moment(startDate).locale(i18n.language).add(i, "days");
				tempDates.push(date.startOf("day"));
			}
			setDates(tempDates);
		}
	}, [dates, i18n.language, selectedDate]);

	const prevWeek = () => {
		performAsyncFunction(async () => {
			setLoading(true);
			let prevWeekDay = moment(selectedDate).startOf("week").subtract(7, "days");
			await PopolaDisponibilitaSettimanale(prevWeekDay);
			await OnClick(prevWeekDay);
			setLoading(false);
		}, handleError);
	};

	const nextWeek = () => {
		performAsyncFunction(async () => {
			setLoading(true);
			let nextWeekDay = moment(selectedDate).startOf("week").add(7, "days");
			await PopolaDisponibilitaSettimanale(nextWeekDay);
			await OnClick(nextWeekDay);
			setLoading(false);
		}, handleError);
	};

	const CheckDateAvailable = (date: Moment) => {
		if (!AvailableDates) return false;
		let res = AvailableDates?.find((dt) => {
			return dt.isSame(date, "day");
		});
		return res !== undefined;
	};

	const OnClickDate = async (date: Moment) => {
		if (date.isBefore(moment().startOf("day")) || !CheckDateAvailable(date) || loading) return;
		performAsyncFunction(async () => {
			await OnClick(moment(date.toDate()));
		}, handleError);
	};

	return (
		<div id="calendar-strip">
			<Spin spinning={loading} size="small">
				<div className="dates-row">
					{dates.map((date, index) => (
						<div
							className={`day-container ${date.isSame(selectedDate, "day") ? "selected" : ""} ${CheckDateAvailable(date) ? "active" : "disabled"}`}
							onClick={() => OnClickDate(date)}
							onKeyDown={(event) => {
								if (event.key === "Enter") {
									OnClickDate(date);
								}
							}}
							role="button"
							tabIndex={index}
							key={index}
						>
							<div className="weekday">{date.format("ddd")}</div>
							<div className="date">{date.format("D")}</div>
						</div>
					))}
				</div>
				<div className="month-row">
					{!dates?.find((date) => {
						return moment(date).isSameOrBefore(moment());
					}) ? (
						<span className="arrow" role="button" tabIndex={0} aria-label={t("settimana-precedente")} onKeyDownCapture={prevWeek} onClick={prevWeek}>
							<FaAngleLeft size={20} />
						</span>
					) : (
						<span className="arrow"></span>
					)}
					<div>{selectedDate?.format("LL")}</div>
					<span className="arrow" role="button" tabIndex={0} aria-label={t("settimana-successiva")} onKeyDownCapture={nextWeek} onClick={nextWeek}>
						<FaAngleRight size={20} onClick={nextWeek} />
					</span>
				</div>
			</Spin>
		</div>
	);
};

export default Enhanced(CalendarStrip, { componentNamespace: "CalendarStrip" });
